import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import classNames from '../pdf.module.scss';
import * as models from '../../../../utils/models';

const MTSummarySheet = (props: models.PDFVIPageProps) => {
	const getDangeHeaderClassName = (): string => {
		return classNames['visual-inspection-body-header-danger'];
	};

	return (
		<div className={classNames['visual-inspection']}>
			<div className={classNames['visual-inspection-body']}>
				<div className={getDangeHeaderClassName()}>Anomaly Report</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>{props.general}</p>
				</div>
			</div>
			<div className={classNames['visual-inspection-body']}>
				<div className={getDangeHeaderClassName()}>
					Remarks & Recommendations:
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>{props.remarks}</p>
				</div>
			</div>

			<div className="border-horizontal-light">
				<PDFTablePage columns={summaryColumns} data={summaryData} />
			</div>
		</div>
	);
};

const getColumnStyle = (): React.CSSProperties => {
	return { textAlign: 'left' };
};

const summaryColumns: models.Column[] = [
	{
		path: 'description',
		label: 'Description',
		style: () => getColumnStyle(),
	},
	{ path: 'photoRef', label: 'Photo Reference' },
];

const summaryData: { description: string; photoRef: string }[] = [
	{
		description:
			'View of Patch Weld Joints on 4" Hota Water Line on Module - P2 at Process Deck.',
		photoRef: 'Yes',
	},
	{
		description: 'Weld Joints of Line after Surface Preparation.',
		photoRef: 'Yes',
	},
	{
		description: 'View of Weld Joints after White Contrast Application.',
		photoRef: 'Yes',
	},
	{
		description: 'View of Weld Joints during MPI',
		photoRef: 'Yes',
	},
];

export default MTSummarySheet;
